import React, {useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {noticeListInterface} from "./CookieSetComponent";
import { getCookie, setCookie } from '@/util/cookie';
import Logo from '../logo/logo';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { mediaUrl } from '@/util/util';

function PopNotification({popupNumber, popupContent, showLength, setShowLength}:
                             {popupNumber: number, popupContent: noticeListInterface, showLength: number, setShowLength: any}) {
    const ad_cookie = getCookie(`ad_${popupNumber}`)
    const [pnShow, setPnShow] = useState<boolean>(ad_cookie == "1" ? true : false)
    const [bodyShow, setBodyShow] = useState<"" | "fade-out-hide-active">("")

    const router = useRouter()

    const a = useTranslations("Sentence")

    function handleClose(){
        setBodyShow("fade-out-hide-active")
        setTimeout(()=> {
            setPnShow(false)
            setShowLength(showLength - 1)
        }, 250)
    }
    function handleCookieDeleteClose(){
        handleClose()

        const dayAgo = new Date(new Date().getTime() + (60000 * 60 * 24))
        // const dayAgo = new Date(new Date().getTime() + 5000)
        setCookie(`ad_${popupNumber}`, "0", {
            path: '/', expires: dayAgo
        })
    }

    return (
        pnShow ?
            <div className={`pn-body ${bodyShow} ad_${popupNumber}`}>
                <span className={"pn-close"} onClick={handleClose}>
                    <FontAwesomeIcon icon={faXmark} />
                </span>
                <header className='pn-title m-t-10 m-b-10'>
                    <Logo />
                </header>

                <main className={"pn-content"}>
                    <img src={mediaUrl(popupContent.image)} alt="" onClick={e=> {
                        if(popupContent.redirect_url) router.push(popupContent.redirect_url)
                    }} />
                </main>

                <div className="btn-area">
                    <button onClick={handleCookieDeleteClose}>{a("CloseToday")}</button>
                </div>
            </div>
        : <></>
    );
}

export default PopNotification;